import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-resultado',
  templateUrl: './informe-resultado.component.html',
  styleUrls: ['./informe-resultado.component.scss']
})
export class InformeResultadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
